import React from 'react';
import { ErrorNotifier } from 'javascripts/shared/utils/error_notifier';

const undefinedShoppingCartActionHandler = (...[, calledMethod]) => {
  return () => {
    ErrorNotifier.notify(`ShoppingCartContext method ${calledMethod.toString()} called without a provider.`);
    // By default, reject the promise so if this does leak, we give an indication that the operation failed.
    return Promise.reject(new Error('Sorry, something has gone wrong.'));
  };
};

const actionProxy = new Proxy({}, { get: undefinedShoppingCartActionHandler });

export const ShoppingCartContext = React.createContext(actionProxy);
ShoppingCartContext.displayName = 'Shopping Cart Context';
